import { motion } from 'framer-motion';
import { features } from '../data/site';
import SectionHeader from './SectionHeader';

export default function FeatureGrid() {
  return (
    <section className="py-24" id="features">
      <div className="container-page">
        <SectionHeader
          eyebrow="Features"
          title="A cleaner bridge from product idea to Shopify listing."
          description="DropBridge gives merchants the control they need before supplier product data touches the storefront."
        />
        <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <motion.article
              key={feature.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ delay: index * 0.05, duration: 0.45 }}
              className="surface rounded-2xl p-6 transition hover:-translate-y-1 hover:border-teal-300/80"
            >
              <div className="grid h-12 w-12 place-items-center rounded-2xl bg-teal-100 text-teal-700 dark:bg-teal-400/10 dark:text-teal-300">
                <feature.icon size={22} />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-slate-950 dark:text-white">
                {feature.title}
              </h3>
              <p className="mt-3 leading-7 text-slate-600 dark:text-slate-300">
                {feature.description}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
